import type { RouteLocation } from "./types";
import type { components as InternalOpenAPI } from "@/autogen/internal-openapi";

export type Kind =
  | InternalOpenAPI["schemas"]["SearchResultType"]
  | "code"
  | "conversation"
  | "snippet"
  | "socialmention"
  | "webmention";

export type Redirect =
  | {
      type: "route";
      route: RouteLocation;
    }
  | {
      type: "url";
      url: string;
    };

export const getRouteRedirect = (kind: Kind, id: string): Redirect => {
  switch (kind) {
    case "attachment":
      return {
        type: "route",
        route: { name: "/settings/data/attachments/[id]", params: { id: id } },
      };
    case "automation":
      return {
        type: "route",
        route: { name: "/automations/[id]", params: { id: id } },
      };
    case "code":
      return {
        type: "url",
        url: `https://docs.buttondown.com/api-error-codes#${id}`,
      };
    case "comment":
      return {
        type: "route",
        route: { name: "/comments", params: {} },
      };
    case "conversation":
      return {
        type: "route",
        route: { name: "/inbox", params: {} },
      };
    case "email":
      return {
        type: "route",
        route: { name: "/emails.[id]", params: { id: id } },
      };
    case "external_feed":
      return {
        type: "route",
        route: { name: "/feeds/[id]", params: { id: id } },
      };
    case "historical_email":
      return {
        type: "route",
        route: {
          name: "/emails.[id]/history.[[historyId]]",
          params: { id, historyId: id },
        },
      };
    case "request":
      return {
        type: "route",
        route: { name: "/requests/[id]", params: { id: id } },
      };
    case "snippet":
      return {
        type: "route",
        route: { name: "/settings/snippets.[id]", params: { id: id } },
      };
    case "socialmention":
      return {
        type: "route",
        route: { name: "/mentions/[id]", params: { id: id } },
      };
    case "stripe_customer":
      return {
        type: "url",
        url: `https://dashboard.stripe.com/customers/${id}`,
      };
    case "stripe_subscription":
      return {
        type: "url",
        url: `https://dashboard.stripe.com/subscriptions/${id}`,
      };
    case "subscriber":
      return {
        type: "route",
        route: { name: "/subscribers/[id]", params: { id: id } },
      };
    case "survey":
      return {
        type: "route",
        route: { name: "/surveys/[id]", params: { id: id } },
      };
    case "survey_response":
      return {
        type: "route",
        route: { name: "/surveys/[id]", params: { id: id } },
      };
    case "tag":
      return {
        type: "route",
        route: { name: "/tags/[id]", params: { id: id } },
      };
    case "webmention":
      return {
        type: "route",
        route: { name: "/mentions/[id]", params: { id: id } },
      };
    case "webhook":
      return {
        type: "route",
        route: { name: "/webhooks/[id]", params: { id: id } },
      };
    case "invitation":
      return {
        type: "route",
        route: { name: "/settings/team/[id]/", params: { id: id } },
      };
    case "message":
      return {
        type: "route",
        route: { name: "/inbox", params: {} },
      };

    case "documentation":
    case "newsletter":
    case "note":
    case "page":
      throw new Error(`unsupported kind`);
  }

  kind satisfies never;
};
